var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 9.99618C10.6563 9.99618 11.9989 8.65476 11.9989 7.00004C11.9989 5.34532 10.6563 4.00391 9.00008 4.00391C7.34385 4.00391 6.00122 5.34532 6.00122 7.00004C6.00122 8.65476 7.34385 9.99618 9.00008 9.99618Z",
    fill: "#223D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4502 5.06674C16.2873 3.17457 13.6424 0 9 0C4.35757 0 1.71274 3.17457 0.549761 5.06674C-0.183254 6.25149 -0.183254 7.74851 0.549761 8.93326C1.71274 10.8254 4.35757 14 9 14C13.6424 14 16.2873 10.8254 17.4502 8.93326C18.1833 7.74851 18.1833 6.25149 17.4502 5.06674ZM9 11.4942C6.51548 11.4942 4.50171 9.48191 4.50171 7C4.50171 4.51809 6.51584 2.5058 9 2.5058C11.4842 2.5058 13.4983 4.51809 13.4983 7C13.4958 9.48121 11.4831 11.4917 9 11.4942Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVer);
export default __webpack_public_path__ + "static/media/ver.154597400436339a4b18b0cee4b0815e.svg";
export { ForwardRef as ReactComponent };